import React, { useState, useEffect, useReducer } from "react";

import axios from "axios";
import { getReducer } from "../../../utils";

import "./css/contact.css";

import LoadingBox from "../../compoment/LoadingBox";
import MessageBox from "../../compoment/MessageBox";

import Enrollment from "../enrollment/compoment/Enrollment";
import ModalMap from "./compoment/ModalMap";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS_NAME_COMPANY":
      return { ...state, nameCompany: action.payload, loading: false };
    case "FETCH_SUCCESS_INFO_COMPANY":
      return { ...state, infoCompany: action.payload, loading: false };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const ContactScreen = () => {
  const [{ loading, error, nameCompany, infoCompany }, dispatch] = useReducer(
    getReducer(reducer),
    {
      nameCompany: null,
      infoCompany: [],
      loading: true,
      error: "",
    }
  );

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: "FETCH_REQUEST" });
      try {
        const resultNameCompany = await axios.get(
          "/page-section/public/shows?pageSlug=trang-chu"
        );
        const nameCompany = resultNameCompany.data.data
          .find(item => item.sectionType === "infoCompany")
          ?.content.find(item => item.key === "name");

        dispatch({
          type: "FETCH_SUCCESS_NAME_COMPANY",
          payload: nameCompany,
        });

        const resultPageSection = await axios.get(
          "/page-section/public/shows?pageSlug=lien-he"
        );

        dispatch({
          type: "FETCH_SUCCESS_INFO_COMPANY",
          payload: resultPageSection.data.data,
        });
      } catch (err) {
        dispatch({ type: "FETCH_FAIL", payload: err.message });
      }
    };
    fetchData();
  }, []);

  const [modalShow, setModalShow] = useState(false);
  const [mapShow, setMapShow] = useState(null);
  const [isSubMenu, setIsSubMenu] = useState(null);

  const toggleSubMenu = idx => {
    setIsSubMenu(isSubMenu === idx ? null : idx);
  };

  return loading ? (
    <LoadingBox />
  ) : error ? (
    <MessageBox variant="danger"> {error} </MessageBox>
  ) : (
    <div>
      <section
        className="section-contact  lazy-bg skeleton loaded"
        data-bg="url/images/baner-lien-he.webp)"
        style={{
          backgroundImage: 'url("./images/baner-lien-he.jpg")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="olay-contact">
          <div className="container ">
            <h1 className="box-title text-center ">Liên hệ - góp ý</h1>
          </div>
        </div>
      </section>
      <div className="mb-5 bg-contact">
        <div className="bg-half-left" />

        <div className="container">
          <div className="row">
            <div className="col-md-6 col-12 form-contact">
              <Enrollment />
            </div>
            <div className="col-md-6 col-12 info-contact">
              <h2 className="text-center default-box-title">
                Thông tin liên hệ
              </h2>
              <div className="contact-menu ">
                <ul>
                  {infoCompany.map((item, index) => (
                    <React.Fragment key={item.id || index}>
                      <li className="position-relative">
                        <div
                          className={`dropdown-btn px-2 ${
                            isSubMenu === index ? "active" : ""
                          }`}
                          onClick={() => toggleSubMenu(index)}
                        >
                          <span className="title">
                            {item.content[0].value}

                            <i
                              className={`icon-angle-down ${
                                isSubMenu === index ? "rotate-up" : ""
                              }`}
                            ></i>
                          </span>
                        </div>
                      </li>
                      <ul
                        className={`dropdown-contact ${
                          isSubMenu === index ? "show" : ""
                        }`}
                      >
                        <li>
                          <p style={{ textTransform: "uppercase" }}>
                            <b>
                              {nameCompany.value +
                                " - " +
                                item.content[0].value}
                            </b>
                          </p>
                          {item.content
                            .slice(1, item.content.length - 2)
                            .map((content, idx) => (
                              <p key={idx}>
                                {content.title + ": " + content.value}
                              </p>
                            ))}
                          <p style={{ textAlign: "right", cursor: "pointer" }}>
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setModalShow(true);
                                setMapShow(
                                  item.content[item.content.length - 1].value
                                );
                              }}
                            >
                              Xem bản đồ &nbsp;
                              <i className="fas fa-arrow-right px-2"></i>
                            </span>
                          </p>
                        </li>
                      </ul>
                    </React.Fragment>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalMap
        show={modalShow}
        onHide={() => setModalShow(false)}
        mapShow={mapShow}
      />
    </div>
  );
};
export default ContactScreen;
